import React from "react";
import { useTranslation } from "react-i18next";

function RequirementCard({ requirement }) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col self-center p-3 mt-4 w-full bg-white rounded-xl border border-solid border-stone-200 ">
      <div className="gap-3 self-stretch w-full text-lg font-medium text-indigo-600 whitespace-nowrap">
        {t("base.requirement")}
      </div>
      <div className="mt-3 text-xs text-neutral-500">{requirement}</div>
    </div>
  );
}

export default RequirementCard;
